import _ from 'lodash';
import { connect } from 'react-redux';
import { get, getDetails, update, add, exportToQuickbooks, invalidate } from '../../modules/billing/vendorBill';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	let vendorBill;
	let vendorBillId;

	if (ownProps.vendorBill) {
		vendorBill = ownProps.vendorBill;
	} else {
		vendorBillId = ownProps.vendorBillId
			? ownProps.vendorBillId
			: _.get(ownProps, ['match', 'params', 'vendorBillId']);
		vendorBill = _.get(state.maps, ['vendorBill', vendorBillId]);
	}

	/** @namespace state.maps.bolNumberToInvoice **/
	/** @namespace state.maps.carrierPoNumberToInvoice **/
	return {
		vendorBill,
		userMap: state.maps.user,
		quickbooksCustomerMap: state.maps.quickbooksCustomer,
		quickbooksTermMap: state.maps.quickbooksTerm,
		quickbooksVendorMap: state.maps.quickbooksVendor,
		stationInvoiceMap: state.maps.stationInvoice,
		bulkInvoiceMap: state.maps.bulkInvoice,
		rackTransferMap: state.maps.rackTransfer,
		bulkCustomerMap: state.maps.bulkCustomer,
		resourceMap: state.maps.resource,
		bolNumberToInvoiceMap: state.maps.bolNumberToInvoice,
		carrierPoNumberToInvoiceMap: state.maps.carrierPoNumberToInvoice,
		stationDeliveryMap: state.maps.stationDelivery,
		bulkDeliveryMap: state.maps.bulkDelivery,
		stationMap: state.maps.station,
		carrierMap: state.maps.carrier,
		terminalMap: state.maps.terminal,
		supplierMap: state.maps.supplier,
		invoiceDocumentMap: state.maps.invoiceDocument,
		railcarMap: state.maps.railcar,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getVendorBill: get,
			getVendorBillDetails: getDetails,
			addVendorBill: add,
			updateVendorBill: update,
			exportVendorBill: exportToQuickbooks,
			invalidateVendorBill: invalidate,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
